// API helpers for the question editor (all calls are authenticated with the `sessionId&organizationId` token)

const base = () => process.env.REACT_APP_BACKEND_URL;

async function request(path, token, body) {
  const isForm = body instanceof FormData;
  const res = await fetch(`${base()}/${path}`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      ...(isForm ? {} : { "Content-Type": "application/json" }),
    },
    body: isForm ? body : JSON.stringify(body || {}),
  });
  const json = await res.json().catch(() => ({}));
  if (!res.ok || json.success === false) {
    throw new Error(json.message || json.error || "Request failed");
  }
  return json;
}

export const getAdminQuestions = ({ token, themeName }) => request("getAdminQuestions", token, { themeName });

export const deleteQuestion = ({ token, id }) => request("deleteQuestion", token, { id });

export const exportQuestionsCSV = ({ token, themeName }) => request("exportQuestionsCSV", token, { themeName });

/** formData: themeName, action (add|edit), edit_id, question, answer, reference_file */
export const saveQuestion = ({ token, formData }) => request("saveAdminQuestions", token, formData);

/** formData: themeName, file */
export const importQuestionsCSV = ({ token, formData }) => request("importQuestionsCSV", token, formData);
